import { z } from 'zod';

// History item schema - matches the actual API response
export const walletTransactionHistoryItemSchema = z.object({
  transactionDate: z.string(),
  amount: z.number(),
  message: z.string(),
});

// Data wrapper schema
export const walletTransactionsDataSchema = z.object({
  hasSavingWallet: z.boolean(),
  totalPoints: z.number(),
  history: z.array(walletTransactionHistoryItemSchema),
});

// Full response schema
export const walletTransactionsResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  status: z.string(),
  data: walletTransactionsDataSchema,
});

// Legacy transaction item schema for backward compatibility
export const walletTransactionItemSchema = z.object({
  transactionId: z.string().nullable().optional(),
  transactionDate: z.string().nullable().optional(),
  season: z.string().nullable().optional(),
  memberId: z.number().nullable().optional(),
  transactionTy: z.number().nullable().optional(),
  walletStatusTy: z.number().nullable().optional(),
  currency: z.string().nullable().optional(),
  earnedAmount: z.number().nullable().optional(),
  fee: z.number().nullable().optional(),
  amount: z.number().nullable().optional(),
  reason: z.string().nullable().optional(),
  memo: z.string().nullable().optional(),
  message: z.string().nullable().optional(),
  internalMemo: z.string().nullable().optional(),
  entryBy: z.number().nullable().optional(),
  updateBy: z.number().nullable().optional(),
  entryDate: z.string().nullable().optional(),
  updateDate: z.string().nullable().optional(),
});

export type WalletTransactionHistoryItem = z.infer<typeof walletTransactionHistoryItemSchema>;
export type WalletTransactionsData = z.infer<typeof walletTransactionsDataSchema>;
export type WalletTransactionsResponse = z.infer<typeof walletTransactionsResponseSchema>;
export type WalletTransactionItem = z.infer<typeof walletTransactionItemSchema>;